import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row suggested-drg-pane" }
const _hoisted_2 = { class: "iodine-padding-right-md column primary-row" }
const _hoisted_3 = { class: "suggested-drg" }
const _hoisted_4 = { class: "io-mfe-ig-suggested-drg-pane-chip" }
const _hoisted_5 = { class: "col codes-item-description" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col weight-title" }, " Weight ", -1)
const _hoisted_7 = { class: "col weight-value" }

import {SuggestedDrgDataModel} from 'components/resources/SuggestedDrgData.model';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestedDrgPane',
  props: {
    suggestedDrgDataModel: {}
  },
  setup(__props: any) {

  const props = __props;

  function getChip(description: string) {

    if (description) {
      if (description.indexOf('MCC') != -1) {
        return 'MCC';
      }

      if (description.indexOf('CC') != -1) {
        return 'CC';
      }
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.suggestedDrgDataModel?.suggestedDrg), 1),
      _createElementVNode("div", _hoisted_4, [
        (getChip(props.suggestedDrgDataModel?.description))
          ? (_openBlock(), _createBlock(_component_q_chip, {
              key: 0,
              class: _normalizeClass(getChip(props.suggestedDrgDataModel?.description))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getChip(props.suggestedDrgDataModel?.description)), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString(props.suggestedDrgDataModel?.description), 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(props.suggestedDrgDataModel?.weight), 1)
    ])
  ]))
}
}

})